'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _url = require('url');

var _url2 = _interopRequireDefault(_url);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function PlaceList(props) {
  var items = props.items,
      location = props.location;


  return _react2.default.createElement(
    'ul',
    { className: 'tags' },
    items.length ? items.map(function (item) {
      return _react2.default.createElement(
        'li',
        { className: 'tag', key: item.id },
        _react2.default.createElement(
          _reactRouter.Link,
          { to: (0, _extends3.default)({}, location, { pathname: _url2.default.parse(item.pageUrl).pathname }) },
          item.name
        )
      );
    }) : null
  );
} // PlaceList

PlaceList.propTypes = {
  items: _react.PropTypes.array.isRequired,
  location: _react.PropTypes.object.isRequired
};

exports.default = PlaceList;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PlaceList.js
// module id = 1220
// module chunks = 0